import React, { PropsWithChildren, useState } from "react";
import "./AmpFloatingActionButton.css";


export interface FabProps extends PropsWithChildren {
    elementScrollQuery: string;
}

export default function Fab(props: FabProps) {

    const isSmallDevice = window.innerWidth < 500;
    const [hasScrolled, setHasScrolled] = useState(false)

    window.addEventListener("scroll", () => {
        setTimeout(() => {
            if(window.scrollY === 0) {
                setHasScrolled(false);
            } else if (window.scrollY > 0) {
                setHasScrolled(true);
            }
        }, 500)
    });

    if (!isSmallDevice) {
        return <></>;
    }

    const onClick = () => {
        (document.querySelector(props.elementScrollQuery) as Element).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest" });
        setHasScrolled(true);
    }

    return (
        <>
            {
                !hasScrolled &&
                (<div className="fab-top" onClick={() => onClick()}>
                    <div className="fab">{props.children}</div>
                </div>)
            }
        </>
    )
}